(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ba-hit-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  const mobile = window.matchMedia('(max-width: 749px)');
  const records = new Map();
  const retained = '[data-ba-hit-open], .ba-hit-archive-card__image, dialog, template, script, style';

  function syncGallery(gallery) {
    gallery.querySelectorAll('[data-ba-hit-card]').forEach(function (card) {
      if (card.hasAttribute('data-ba-inline-card')) return;
      let record = records.get(card);
      if (!record) {
        record = { entries: [], details: null, mobileOpen: false };
        records.set(card, record);
      }
      if (mobile.matches && !record.details) {
        const nodes = Array.from(card.childNodes).filter(function (node) {
          return node.nodeType === 1 ? !node.matches(retained) : node.nodeType === 3 && node.textContent.trim() !== '';
        });
        if (!nodes.length) return;
        const details = document.createElement('details');
        details.className = 'ba-hit-details';
        const summary = document.createElement('summary');
        summary.className = 'ba-hit-details__summary';
        const label = document.createElement('span');
        label.textContent = gallery.dataset.baDetailsLabel;
        summary.append(label);
        const title = card.querySelector('h3');
        if (title) {
          const context = document.createElement('span');
          context.className = 'visually-hidden';
          context.textContent = ': ' + title.textContent.trim();
          summary.append(context);
        }
        const body = document.createElement('div');
        body.className = 'ba-hit-details__body';
        details.append(summary, body);
        record.entries = nodes.map(function (node) {
          const marker = document.createComment('ba-hit-details');
          card.insertBefore(marker, node);
          body.append(node);
          return { node: node, marker: marker };
        });
        details.open = record.mobileOpen;
        card.append(details);
        record.details = details;
      } else if (!mobile.matches && record.details) {
        record.mobileOpen = record.details.open;
        record.entries.forEach(function (entry) {
          entry.marker.replaceWith(entry.node);
        });
        record.details.remove();
        record.details = null;
        record.entries = [];
      }
    });
  }

  function sync(root) {
    records.forEach(function (_record, card) {
      if (!card.isConnected) records.delete(card);
    });
    if (root.matches && root.matches('.ba-hit-gallery')) syncGallery(root);
    root.querySelectorAll('.ba-hit-gallery').forEach(syncGallery);
  }

  function ready() { sync(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }
  mobile.addEventListener('change', ready);
  document.addEventListener('ba:hits:updated', function (event) { sync(event.target); });
  document.addEventListener('shopify:section:load', function (event) { sync(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    records.forEach(function (_record, card) {
      if (event.target.contains(card)) records.delete(card);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
